export default __webpack_public_path__ + "static/media/developer-mode-light.29dfa128.svg";